export default "__VITE_ASSET__yP0PX7S$__"